export const privilegesRolesSelector = state => state.privileges.roles;
export const privilegesListSelector = state => state.privileges.list;
